import Typography from 'src/components/Text/Text';
import { themes } from 'src/theme/theme';
import React from 'react';
import {
  View,
  Text,
  StyleSheet,
  Image,
  TouchableOpacity,
  ImageSourcePropType,
  GestureResponderEvent,
} from 'react-native';
import imageDelete from 'src/assets/delete-3x.png';
import imageEdit from 'src/assets/edit-3x.png';
interface CardProps {
  imageSrc: ImageSourcePropType;
  imageWidth?: number; // Image width (optional, default is 40)
  imageHeight?: number; // Image height (optional, default is 40)
  title: string; // Title text
  description: string; // Description text
  onEdit: (event: GestureResponderEvent) => void; // Edit button click handler
  onDelete: (event: GestureResponderEvent) => void; // Delete button click handler
  testID?: string;
}

const BypassCard: React.FC<CardProps> = ({
  imageSrc,
  imageWidth = 40,
  imageHeight = 40,
  title,
  description,
  onEdit,
  onDelete,
  testID,
}) => {
  return (
    <View style={styles.card} testID={testID}>
      {/* Top Row */}
      <View style={styles.topRow}>
        {/* Left: Image */}
        <Image source={imageSrc} style={{ width: imageWidth, height: imageHeight }} />

        {/* Right: Edit and Delete Icons */}
        <View style={styles.actions}>
          <TouchableOpacity onPress={onDelete} style={styles.actionIcon}>
            <Image
              source={imageDelete}
              style={styles.deletImage}
              accessibilityLabel="delete-img-icon"
            />
          </TouchableOpacity>
          <TouchableOpacity onPress={onEdit} style={styles.actionIcon}>
            <Image source={imageEdit} style={styles.editImage} accessibilityLabel="edit-img-icon" />
          </TouchableOpacity>
        </View>
      </View>

      {/* Title */}
      <Typography variant="h4">{title}</Typography>

      {/* Description */}
      <Text style={styles.description}>{description}</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  card: {
    backgroundColor: themes.light.white[1],
    borderRadius: 12,
    padding: 12,
  },
  topRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 8,
  },
  actions: {
    flexDirection: 'row',
  },
  actionIcon: {
    marginLeft: 8,
    width: 20,
    height: 20,
  },
  description: {
    fontSize: 14,
    color: themes.light.gray_blue[3],
  },
  editImage: { width: 15, height: 15 },
  deletImage: { width: 15, height: 17 },
});

export default BypassCard;
